import {
	Directive,
	Input,
	OnDestroy,
	HostListener,
	ElementRef,
	Type,
	ComponentRef,
	ApplicationRef,
	Injector,
	ReflectiveInjector,
	EmbeddedViewRef,
	ComponentFactoryResolver
} from '@angular/core';

import { TooltipComponent } from './tooltip.component';


export class TooltipDirective implements OnDestroy {

	 public content: string | Type<any>;
	 public position: string = '';
	 public maxWidth: string = '';
	 public showTooltip: boolean = true;
	 public keepForTooltipHover: boolean = false;
	 public waitTimeForTooltipHover: number = 1000;
	 public data: any;

	private isHovered: boolean = false;
	private intervalId: any = null;
	private componentRef: ComponentRef<TooltipComponent>;

	constructor(
		private element: ElementRef,
		private injector: Injector,
		private appRef: ApplicationRef,
		private resolver: ComponentFactoryResolver) { }

	// Lifecycle Hooks
	public ngOnDestroy(): void {
		this.destroy();
	}

	
	public onMouseEnter(): void {
		this.isHovered = true;

		if (!this.showTooltip) {
			return;
		}
		if (this.componentRef) {
			return;
		}

		this.initTooltip();
	}

	
	public onMouseLeave(): void {
		this.isHovered = false;

		if (!this.showTooltip) {
			return;
		}
		if (!this.componentRef) {
			return;
		}
		if (!this.componentRef.instance) {
			return;
		}

		if (this.keepForTooltipHover) {
			this.watchHover();
		} else {
			this.destroy();
		}
	}

	private watchHover(): void {
		if (this.intervalId !== null) {
			return;
		}

		this.intervalId = setInterval(() => {
			if (!this.isHovered && (this.componentRef && !this.componentRef.instance.isHovered)) {
				this.destroy();
			}
		}, this.waitTimeForTooltipHover);
	}

	private initTooltip(): void {
		let optionsToPass: any  = {
			provide: 'tooltipConfig',
			useValue: {
				host: this.element.nativeElement,
				content: this.content,
				position: this.position,
				maxWidth: this.maxWidth,
				data: this.data
			}
		};

		const injector = ReflectiveInjector.resolveAndCreate([optionsToPass], this.injector);
		this.componentRef = this.resolver.resolveComponentFactory(TooltipComponent).create(injector);

		// attach the new created component to body
		this.appRef.attachView(this.componentRef.hostView);
		document.body.appendChild((this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement);
	}

	private destroy(): void {
		clearInterval(this.intervalId);
		this.intervalId = null;

		if (this.componentRef) {
			this.appRef.detachView(this.componentRef.hostView);
			this.componentRef.destroy();
		}
		this.componentRef = null;
	}
static ctorParameters() { return [ { type: ElementRef }, { type: Injector }, { type: ApplicationRef }, { type: ComponentFactoryResolver } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/components/tooltip/tooltip.directive.ts